import React from 'react';

const UsersDepartments = () => {
  return (
    <div className="card">
      <div className="card-header">
        <h2 className="text-xl">Działy użytkownika</h2>
      </div>
      <div className="card-body">
        <p className="text-gray-600">Działy użytkownika - do implementacji</p>
      </div>
    </div>
  );
};

export default UsersDepartments;
